import { useEffect } from 'react';
import axios from 'axios';

export function useFetchServices(
  setServices,
  setHasMore,
  setFetchState,
  page,
  hasFetched
) {

  useEffect(() => {

    if (hasFetched.current) return;

    const fetchServices = async () => {

      try {

        const response = await axios.get(
          '/server/ikea_services_function/services',
          {
            params: {
              page,
              perPage: 200,
            },
          }
        );

        const {
          data: { Services, hasMore },
        } = response.data;

        setServices((prev) => [
          ...new Map(
            [...prev, ...Services].map((item) => [item.id, item])
          ).values(),
        ]);

        setHasMore(hasMore);
        setFetchState('fetched');
        hasFetched.current = true;

      } catch (err) {
        console.error(err.response || err);
        setFetchState('error');
      }
    };

    fetchServices();

  }, [page]);

}
